/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Marker_Km_LabelInputs */

const en_ui_studio_marker_km_label = /** @type {(inputs: Ui_Studio_Marker_Km_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance from start`)
};

const de_ui_studio_marker_km_label = /** @type {(inputs: Ui_Studio_Marker_Km_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernung vom Start`)
};

/**
* | output |
* | --- |
* | "Distance from start" |
*
* @param {Ui_Studio_Marker_Km_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_marker_km_label = /** @type {((inputs?: Ui_Studio_Marker_Km_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Marker_Km_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_marker_km_label(inputs)
	return de_ui_studio_marker_km_label(inputs)
});